import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import {
  InputBox,
  DataInputBox,
  ToggleBox,
  ToggleLabel,
  ToggleWrap,
  Toggle,
  ToggleButton,
  InputWrap,
  DataInput
} from 'src/components/pages/Portfolio/styles';
const PortfolioToggleInput = ({
  title,
  registerNameBefore,
  registerNameAfter,
  toggleDefault = false
}: {
  title: string;
  registerNameBefore: string;
  registerNameAfter: string;
  toggleDefault: boolean;
}) => {
  const [isToggleOn, setIsToggleOn] = useState(toggleDefault);
  const methods = useFormContext();
  return (
    <DataInputBox>
      <ToggleBox>
        <ToggleLabel>{title}</ToggleLabel>
        <ToggleWrap
          onClick={() => {
            setIsToggleOn(prev => !prev);
            if (isToggleOn) {
              methods.setValue(registerNameBefore, '');
              methods.setValue(registerNameAfter, '');
            }
          }}
        >
          <Toggle isToggleOn={isToggleOn}>
            <ToggleButton isToggleOn={isToggleOn} />
          </Toggle>
        </ToggleWrap>
      </ToggleBox>
      {isToggleOn && (
        <InputWrap>
          <DataInput>
            <span style={{ color: '#8E899F' }}>전</span>
            <input
              type="number"
              className="bg-transparent text-white h-54"
              placeholder="0.0kg"
              {...methods.register(registerNameBefore, {
                valueAsNumber: true
              })}
            />
          </DataInput>
          <DataInput>
            <span style={{ color: '#9170F2' }}>후</span>
            <input
              type="number"
              className="bg-transparent text-white h-54"
              placeholder="0.0kg"
              {...methods.register(registerNameAfter, {
                valueAsNumber: true
              })}
            />
          </DataInput>
        </InputWrap>
      )}
    </DataInputBox>
  );
};

export default PortfolioToggleInput;
